<template>
  <uploader
    :file-status-text="fileStatusText"
    :options="options"
    class="uploader-summary"
    @file-success="fileSuccess"
  >
    <uploader-unsupport />
    <uploader-list />

    <uploader-btn class="btn text-sm sm:text-base mt-4 lg:ml-5 mb-0 px-12 py-4 flex items-center justify-center animate">
      {{ $t('summary.attach') }} <DocIcon class="ml-3" />
    </uploader-btn>
  </uploader>
</template>
<script>
import { mapMutations } from 'vuex';
import DocIcon from '@/assets/icons/doc.svg';
import store from '@/store';

export default {
  components: {
    DocIcon,
  },
  data() {
    return {
      options: {
        target: `${process.env.VUE_APP_API_URL}/order/upload`,
        testChunks: false,
        headers: {
          Authorization: `Bearer ${store.state.auth.authToken.access_token}`,
        },
      },
    };
  },
  created() {
    this.clearAllFiles();
  },
  methods: {
    ...mapMutations('order', ['addFile', 'clearAllFiles']),
    fileStatusText(status) {
      const statusTextMap = {
        uploading: 'uploading',
        paused: 'paused',
        waiting: 'waiting',
      };
      if (status === 'success') {
        return 'OK';
      }
      if (status === 'error') {
        return 'error';
      }

      return statusTextMap[status];
    },
    fileSuccess(rootFile, file, message) {
      const response = JSON.parse(message);
      if (response.success) {
        this.addFile(response.data.url);
      }
    },
  },
};
</script>
<style lang="scss">
  .uploader-list {
    margin-left: 20px;
  }
  .uploader-summary {
    width: 100%;
    margin: 20px auto 0;
    font-size: 12px;
  }
  .uploader-summary .uploader-btn {
    width: 250px;
    display: flex;
    position: relative;
    padding: 14px 38px;
    font-size: 16px;
    line-height: 1.4;
    color: #fff;
    border: 0;
    cursor: pointer;
    border-radius: 9px;
    background: #553c9a;
    outline: none;
    &:hover {
      background-color: #4c3785;
    }
  }
  .uploader-file-name i, .uploader-file-size {
    display: none;
  }
  .uploader-summary .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .uploader-file[status=error] .uploader-file-progress, .uploader-file .uploader-file-progress {
    background: none !important;
  }
  .uploader-file {
    @apply text-base text-black-display;
    height: 38px !important;
    margin-left: -12px;
    border-bottom: 0 !important;
  }
  .uploader-file-progress {
    position: absolute;
    width: 100%;
    height: 100%;
    background: none;
    -webkit-transform: translateX(-100%);
            transform: translateX(-100%);
  }
  .uploader-file-actions>span {
    margin-left: 6px;
  }
</style>
